import * as React from 'react'
import { SiteTakeoverCampaignTagLabelCore } from './SiteTakeoverCampaignTagLabelCore'
import type { SiteTakeoverCampaignTagLabelProps } from './siteTakeoverCampaignTagLabel.types'
import { useOpenSiteTakeoverCampaignModal } from '../hooks/useOpenSiteTakeoverCampaignModal'

export { LabelElement } from './SiteTakeoverCampaignTagLabelCore'

/**
 * This is a base 'abstract' label that is used by all the *implementation labels*
 * This should never be used directly. Talk to your designer to discover the correct
 * label type to use in the event you are unsure.
 */
export const SiteTakeoverCampaignTagLabel = React.forwardRef<HTMLSpanElement, SiteTakeoverCampaignTagLabelProps>((props, ref) => {
  const openCampaignModal = useOpenSiteTakeoverCampaignModal()

  return (
    <SiteTakeoverCampaignTagLabelCore
      {...props}
      ref={ref}
      openCampaignModal={openCampaignModal}
    />
  )
})
